/**
 * Whether Tagging's preview plays each row as it is selected (play) or holds still on its first frame
 * (stop). Stored per browser, so the choice holds from one clip and one visit to the next.
 */
export type PreviewMode = 'play' | 'stop';
const KEY = 'studio.taggingPreview';

export function getPreviewMode(): PreviewMode {
  try {
    return localStorage.getItem(KEY) === 'stop' ? 'stop' : 'play';
  } catch {
    return 'play';
  }
}

export function setPreviewMode(mode: PreviewMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* private mode: the choice lasts until the page closes */
  }
}
